import { Injectable } from '@angular/core';
import { BaseService } from './base.service';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})

export class MentorshipDashboardService {

  private statusSource =  new BehaviorSubject<any>(null);

  
  constructor(private base: BaseService) { }
  

  setStatus(tab: any) {
    this.statusSource.next(tab);
  }

  getStatus(): Observable<any>  {
    return this.statusSource.asObservable()
  }

  getCounts(data) {
    return this.base.post('/api/dashboard/metrics', data);
  }

  dataExport(data) {
    return this.base.post("/api/metric-list", data);
  }

  getIndustryWise(data) {
    return  this.base.post('/api/dashboard/industryWiseMentorDistribution', data);
  }

  getExperienceWise(data) {
    return  this.base.post('/api/dashboard/experienceWiseMentorDistribution', data);
  }


}
